"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable */
/* TODO: fix ALL linting errors as some may call out code smells */
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const icons_json_1 = __importDefault(require("./icons.json"));
const icon_module_scss_1 = __importDefault(require("./icon.module.scss"));
/**
 * Return an icon from a provided Icon List
 * @param {string} name - "name" property of icon to be found in iconList
 * @param {array} iconList - JSON Array of Objects
 * @example
 * this.getIcon('icon--star', icons.json);
 */
const getIcon = (name, iconList = icons_json_1.default) => {
    const icon = iconList.filter(icon => icon.name === name);
    if (icon.length === 0) {
        // TODO should this throw an error in the log instead/as well?
        return false;
    }
    else if (icon.length > 1) {
        throw new Error(`More than one icon found with the name '${name}'`);
    }
    else {
        return icon[0];
    }
};
/**
 * Returns Elements (shapes) in SVG
 * @param {Object} svgShapes - Object including SVG elements and nodes (paths, rects, etc.)
 * @example
 * buildSvgEls(icon.svgShapes);
 */
const buildSvgEls = (svgShapes) => {
    const svgElements = Object.keys(svgShapes)
        .filter(key => svgShapes[key])
        .map(svgProp => {
        const shapes = svgShapes[svgProp];
        const Shape = `${svgProp}`;
        return shapes.map((shape, index) => {
            return (0, jsx_runtime_1.jsx)(Shape, { ...shape }, `${svgProp}${index}`);
        });
    });
    return svgElements;
};
const camelize = (str) => {
    return str.replace(/\W+(.)/g, function (match, chr) {
        return chr.toUpperCase();
    });
};
// stateless component!
const Icon = ({ name, className, description, role = 'img', alt, style, width, height, fill, stroke, iconList, titleId, index, ...other }) => {
    const icon = iconList ? getIcon(name, iconList) : getIcon(name);
    titleId = titleId ? titleId : camelize(alt);
    // setup icon className
    const buttonClasses = (0, classnames_1.default)(icon_module_scss_1.default[`${name}`], className);
    const iconProps = {
        name,
        className: buttonClasses,
        role,
        alt: alt || icon.alt,
        description: description || alt,
        viewBox: icon.viewBox,
        fill,
        stroke,
        width: width || icon.width,
        height: height || icon.height,
        style,
        ...other
    };
    // TODO allow for passing in svgs as symbols once we have appropriate assets and webpack setup for symbols/svs
    // ex. <use xlinkHref={`#icons_${props.name}`} />
    const svgContent = icon ? buildSvgEls(icon.svgShapes) : '';
    return ((0, jsx_runtime_1.jsxs)("svg", { ...iconProps, "aria-labelledby": titleId, children: [(0, jsx_runtime_1.jsx)("title", { id: index ? `${titleId}-${index}` : titleId, children: description }), svgContent] }));
};
Icon.propTypes = {
    name: prop_types_1.default.string.isRequired,
    className: prop_types_1.default.string,
    description: prop_types_1.default.string.isRequired,
    titleId: prop_types_1.default.string.isRequired,
    alt: prop_types_1.default.string.isRequired,
    role: prop_types_1.default.string,
    viewBox: prop_types_1.default.string,
    fill: prop_types_1.default.string,
    stroke: prop_types_1.default.string,
    width: prop_types_1.default.string,
    height: prop_types_1.default.string,
    style: prop_types_1.default.object,
    iconList: prop_types_1.default.array,
    index: prop_types_1.default.number,
};
exports.default = Icon;
//# sourceMappingURL=icon.js.map